function once(el, ev, callback) {
  el.addEventListener(ev, (e) => {
    el.removeEventListener(ev, callback);
    callback(e);
  });
}

class IFrame {
  constructor(html) {
    this.html = html;
    this.EL = IFrame.initEL();
    this.copies = 1; // 最后调用打印时,需要克隆部分元素，再选择打印。
    this.imgLoad = null;
  }

  static initEL() {
    const EL = document.createElement('iframe');
    EL.style.border = 'none';
    EL.width = '100%';
    EL.height = '100%';
    return EL;
  }

  // 只要插入新节点,iframe就必须重新初始化内容.
  appendTo(container) {
    container.appendChild(this.EL);
    this.write();
  }

  write() {
    if (!this.EL.parentElement) {
      throw new Error('iframe尚未插入文档');
    }
    const win = this.EL.contentWindow;
    win.document.write(this.html);
    win.document.close();

    // @TODO 如果是背景图片
    const allImg = Array.from(win.document.querySelectorAll('img'));
    this.imgLoad = Promise.all(
      allImg.map(
        (item) => new Promise((rsv) => {
          if (item.complete || item.readyState === 'complete') {
            rsv();
          } else {
            once(item, 'load', rsv);
            once(item, 'error', rsv);
            // once(item,'error',err=>rej(err));
          }
        }),
      ),
    );
  }

  rewrite(html) {
    this.html = html;
    this.write();
  }

  getRealHtml() {
    return this.EL.contentWindow.document.documentElement.outerHTML;
  }

  // 设置打印相关,
  // top:水平偏移,left:垂直偏移,paddinngX:水平边距,paddingY:垂直边距,copies:份数
  set({ copies = 1 }) {
    // 添加style标签,写入样式(margin,padding)

    this.copies = copies;
  }

  destory() {
    this.imgLoad = null;
    this.EL.remove();
  }

  async print() {
    // 图片全部加载完,执行打印
    const win = this.EL && this.EL.contentWindow;
    if (win) {
      await this.imgLoad;
      // @TODO 复制copies份
      for (let i = 0; i < this.copies; i += 1) {
        // 复制
      }

      win.print();
      // 移除复制的DOM.
      setTimeout(() => {}, 0);
    } else {
      throw new Error('iframe没有加载到文档里,无法打印');
    }
  }
}

export default function buildPrint({ source, data }) {
  const render = window.template.compile(source);
  const html = render(data);
  const iframe = new IFrame(html);
  let parent = null;

  function preview(container) {
    if (container instanceof Element) {
      parent = container;
      iframe.appendTo(container);
    } else {
      console.error('preview的参数应为html元素,作为iframe的容器');
    }
  }

  function rewrite({ source: newSource, data: newData }) {
    const newRender = window.template.compile(newSource);
    const newHtml = newRender(newData);
    iframe.rewrite(newHtml);
  }

  async function print() {
    let div;
    if (!parent) {
      div = document.createElement('div');
      div.style.width = 0;
      div.style.height = 0;
      document.body.appendChild(div);
      iframe.appendTo(div);
      // 调用打印需要等待一小会
      await new Promise((rsv) => setTimeout(() => rsv(), 500));
    }
    try {
      await iframe.print();
      if (!parent) {
        document.body.removeChild(div);
      }
    } catch (e) {
      throw new Error(e);
    }
  }

  function getHtml() {
    return iframe.getRealHtml();
  }

  function destroy() {
    // 销毁
    iframe.destory();
  }

  return {
    preview,
    print,
    destroy,
    rewrite,
    getHtml,
  };
}
buildPrint.template = window.template;

